module["exports"] = [
  "Polokwane",
  "Johannesburg",
  "Pretoria",
  "Tshwane",
  "Durban",
  "Pietermaritzburg",
  "Nelspruit",
  "Cape Town",
  "Stellenbosch",
  "Port Elizabeth",
  "East London",
  "Kimberley",
  "Rustenburg",
  "Bloemfontein "
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/en_ZA/address/city_prefix.js
// module id = 2769
// module chunks = 1610